import styled from 'styled-components/macro'

import { theme, fluidSystem, ChartWrapper, mediaM } from 'styled'
import { Root, OptionsRow, DonutButton } from './../DonutQuestion/DonutQuestion.styled'

export { Root, OptionsRow, DonutButton }

export const Chart = styled(ChartWrapper)`
  ${fluidSystem};
  /* flex: 0 999 auto;
  height: 100%;
  width: 100%; */
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    width: 100%;
    height: 100%;
    pointer-events: none;
    user-select: none;
    /* outline: 1px solid tomato; */
    /* overflow: visible; */
  }

  > .Inner {
    /* position: relative;
    width: 100%;
    height: 100%; */
    max-height: 400px;
  }
`

export const AxisLine = styled.path.attrs({
  vectorEffect: 'non-scaling-stroke',
})`
  stroke-width: 1px;
  stroke: #6d6d6d;
  fill: none;
`

export const GuideLine = styled.path.attrs({
  vectorEffect: 'non-scaling-stroke',
})`
  stroke-width: 1px;
  stroke: #dbdbdb;
  stroke-dasharray: 2px 2px;
  fill: none;
`

export const OptionGroup = styled.g.attrs({
  vectorEffect: 'non-scaling-stroke',
})`
  path {
    stroke-width: 2px;
    stroke: ${({ highlight, selected }) =>
      highlight ? theme.colors.secondary : selected ? theme.colors.primary : '#6d6d6d'};
    fill: none;
    transition: stroke 0.25s;
  }
  circle {
    fill: ${({ highlight, selected }) =>
      highlight ? theme.colors.secondary : selected ? theme.colors.primary : '#6d6d6d'};
    transition: fill 0.25s;
  }
`
export const GuideText = styled.text`
  font-size: 10px;
  fill: ${theme.colors.darkGrey};
  user-select: none;

  ${mediaM`
    font-size: 16px;
  `};
`
